import { PARTNER_CODE_SEARCH_PARAM_NAME } from "@/config"
import { useSearchParam } from "@/hooks"

const usePartnerCode = () => {
  const { param, setParam, clearParam } = useSearchParam(
    PARTNER_CODE_SEARCH_PARAM_NAME
  )
  return {
    partnerCode: param,
    setPartnerCode: setParam,
    clearPartnerCode: clearParam,
  }
}

export default usePartnerCode
